import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import "./index.scss";
import "./styles/empCssLibs/variables.scss";
import "./ford.scss";
import "./lincoln.scss";
import * as serviceWorker from "./common/serviceWorker";
import App from "./apps/App";
import MsalAuthWrapper from "./auth/MsalAuthWrapper";
import { msalConfig } from "./auth/authConfig";
import { setupMsalAxiosInterceptor } from "./auth/msalAxiosInterceptor";
import { setMsalInstance } from "./auth/msalInstance";
import i18n from "./common/i18n.js";
import ErrorBoundary from "./errors/ErrorBoundary";

const msalInstance =
  msalConfig.auth?.clientId && msalConfig.auth?.authority
    ? new PublicClientApplication(msalConfig)
    : null;

if (msalInstance) {
  setMsalInstance(msalInstance);
  setupMsalAxiosInterceptor();
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Suspense fallback="">
    <ErrorBoundary>
      {msalInstance ? (
        <MsalProvider instance={msalInstance}>
          <MsalAuthWrapper />
        </MsalProvider>
      ) : (
        <App i18n={i18n} />
      )}
    </ErrorBoundary>
  </Suspense>
);

serviceWorker.unregister();
